import { React, useState } from 'react'
import Layout from '../components/Layouts/Layout'
import { Container, Row, Col, NavLink } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useFormik } from 'formik';
import DynamicDropDownComp from '../components/DynamicDropDownComp';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { FormSelect } from 'react-bootstrap';
import { API_URL, TEST_RIDE_CAMPAIGN_ID, ASSET_URL } from '../config/config';
import CleanNumericInput from '../components/CleanNumericInput';

const Testride = () => {
    const [loading, setLoading] = useState(false);
    const { cId, cSource } = useParams();
    const [allDealersInfo, setAllDealersInfo] = useState([]);
    const [selectedDealerInfo, setSelectedDealerInfo] = useState(null);

    const navigate = useNavigate();

    const citiDataProcessing = (responseData) => {
        if (responseData.status === 200) {
            setAllDealersInfo(responseData.data.response_data.dealers_data);
            return responseData.data.response_data.dealers_data.map((dealer, dealerIndex) => {
                if (dealerIndex === 0) {
                    return ([
                        <option value='' key={`default_${dealerIndex}`}>Choose City</option>,
                        <option value={dealer.dn_id} key={dealerIndex}>{dealer.dn_district} {dealer.dn_state}</option>
                    ])
                } else {
                    return (<option value={dealer.dn_id} key={dealerIndex}>{dealer.dn_district}, {dealer.dn_state}</option>);
                }
            });
        } else {
            return <option value='' key={`default`}>No Cities Found</option>
        }
    }

    const getSelectedDealerInfo = (data) => {
        const selectedDealerInfo = allDealersInfo.filter((item) => (item.dn_id === data));
        setSelectedDealerInfo(selectedDealerInfo[0]);
        if (selectedDealerInfo[0]) {
            setHiddenFields(selectedDealerInfo[0]);
        }
    };
    
    // FORMIK FORM SUBMIT START
    const formik = useFormik({
        initialValues: {
            name: '', email: '', phone: '', enquiried_for_item: '', dn_state: '', dn_district: '', dn_city: '', dn_pinocde: '', campaign_id: ((typeof cId !== "undefined" && cId !== "") ? cId : TEST_RIDE_CAMPAIGN_ID),
            campaign_source: ((typeof cSource !== "undefined" && cSource !== "") ? cSource : "website")
        },
        validate: (values) => {
            let errors = {};
            if (!values.name) { errors.name = 'Name is required'; }
            if (!values.email) { errors.email = 'Required'; }
            if (!values.phone) { errors.phone = 'Required'; }
            if (!values.phone) { errors.phone = 'Required'; } else if (!/^\d{10}$/.test(values.phone)) { errors.phone = 'Only 10 digit numbers are allowed'; }
            if (!values.enquiried_for_item) { errors.enquiried_for_item = 'Required'; }
            return errors;
        },

        onSubmit: (values) => {
            setLoading(true);
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("email", values.email);
            formData.append("phone_number", values.phone);
            formData.append("enquiried_for_item", values.enquiried_for_item);
            formData.append("category", "Item enquiry");

            formData.append("state", values.dn_state);
            formData.append("district", values.dn_district);
            formData.append("city", values.dn_city);
            formData.append("pincode", values.dn_pinocde);

            formData.append("campaign_id", values.campaign_id);
            formData.append("campaign_source", values.campaign_source);

            formData.append("category", "Test ride");
            formData.append("testride_status", "Raised");

            axios.post(API_URL + `atumobile/enquiries/create`, formData)
                .then(response => {
                    setLoading(false);
                    if (response.data.status === 200) {
                        navigate('/testride/success', { state: { message: response.data.message || 'Our team will connect with you.' } });
                    } else {
                        navigate('/testride/error', { state: { message: response.data.message || 'Something went wrong, please try again later.' } });
                    }
                    formik.resetForm();
                }
                ).catch(err => {
                    setLoading(false);
                    console.log(err)
                    navigate('/error', { state: { message: 'An error occurred, please try again later.' } });
                });
        },
        validateOnMount: false,
        validateOnChange: true,
        validateOnBlur: true,
    })
    // FORMIK FORM SUBMIT END

    const setHiddenFields = (dealerInfo) => {
        if (dealerInfo) {
            if (dealerInfo.dn_state) {
                formik.setFieldValue("dn_state", dealerInfo.dn_state);
            } else {
                console.error("dn_state is missing in dealerInfo");
            }

            if (dealerInfo.dn_district) {
                formik.setFieldValue("dn_district", dealerInfo.dn_district);
            } else {
                console.error("dn_district is missing in dealerInfo");
            }

            if (dealerInfo.dn_city) {
                formik.setFieldValue("dn_city", dealerInfo.dn_city);
            } else {
                console.error("dn_city is missing in dealerInfo");
            }

            if (dealerInfo.dn_pinocde) {
                formik.setFieldValue("dn_pinocde", dealerInfo.dn_pinocde);
            } else {
                console.error("dn_pinocde is missing in dealerInfo");
            }
        }
    };

    return (
        <>
            <Layout>
                <section className='testride-header-bg header-bg' style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), url(${ASSET_URL}assets/images/sliders/testride.webp)`}}>
                    <Container>
                        <Row>
                            <Col sm={12} lg={5}>
                                <div className="title">
                                    <h1 className="title-heading"><span>Test Ride</span></h1>
                                    <p className="title-desc">ATUM Charge is the official Test Ride Centre for Atumobile.</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="contact-us bg-grey">
                    <Container>
                        <Row className='mb-5'>
                            <Col>
                                <div className="testRideField d-flex flex-column justify-content-center align-items-center mx-auto mb-2 atc_select">
                                    <h5 className="fw-bold fs-4 m-0 p-0 mb-2">Pick Your Nearest Test Drive Centre</h5>
                                    <DynamicDropDownComp
                                        apiURL={API_URL + 'atumobile/dealers/network/open/list/state/1/search'}
                                        inputName='city' labelName={''}
                                        optionsProcessing={(responseData) => { return citiDataProcessing(responseData); }}
                                        customOnChangeEvents={(e) => { getSelectedDealerInfo(e.target.value) }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        {(selectedDealerInfo !== null && typeof selectedDealerInfo === 'object') && <Row className="contact-card">
                            <Col sm={12} md={6} lg={6} className="left-box">
                                <div className="left-box-card222">
                                    <div className="contact-body">
                                        <h5 className="card-heading">Address Details</h5>
                                        <p className="card-desc">We provide fast and knowledgeable service</p>
                                        <div className="row address-features">
                                            <div className="col-12 col-sm-12 col-md-10 col-lg-10">
                                                <div className="address-feature mx-auto position-relative">
                                                    <div className="address-leftbox"></div>
                                                    <div className="address-feature-icon mx-auto d-flex align-items-center justify-content-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18px" fill="#ed1c24"><path className="fa-primary" d="M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"></path><path className="fa-secondary" d="M505.7 412.3l-8.5 31.2c-71.8-8.7-138.9-32.9-197.8-69.1l20.5-25c55.4 33.4 118.4 55.4 185.8 62.9zM99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8l-25 20.5C101.4 153.7 77.2 86.6 68.4 14.8L99.7 6.3z"></path></svg>
                                                    </div>
                                                    <div className="address-feature-tag fw-semibold text-break"><span><NavLink href="tel:9555333308" className="address-feature-tag fw-semibold text-break">{selectedDealerInfo?.dn_phone}</NavLink></span></div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-10 col-lg-10">
                                                <div className="address-feature mx-auto position-relative">
                                                    <div className="address-leftbox"></div>
                                                    <div className="address-feature-icon mx-auto d-flex align-items-center justify-content-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18px" fill="#ed1c24"><path className="fa-primary" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48z"></path><path className="fa-secondary" style={{ opacity: '0.4' }} d="M0 112V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V112c0 15.1-7.1 29.3-19.2 38.4L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112z"></path></svg>
                                                    </div>
                                                    <div className="address-feature-tag fw-semibold text-break"><span><NavLink href={`mailto:${selectedDealerInfo.dn_email}`} className="address-feature-tag fw-semibold text-break">{selectedDealerInfo?.dn_email}</NavLink></span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row address-features mt-1">
                                            <div className="col-12 col-sm-12 col-md-10 col-lg-10">
                                                <div className="address-feature mx-auto position-relative">
                                                    <div className="address-leftbox"></div>
                                                    <div className="address-feature-icon mx-auto d-flex align-items-center justify-content-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="15px" fill="#ed1c24"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path></svg>
                                                    </div>
                                                    <div className="address-feature-tag fw-semibold text-break">{selectedDealerInfo.dn_street + ", " + selectedDealerInfo.dn_district + ", " + selectedDealerInfo.dn_state + ", " + selectedDealerInfo.dn_pinocde}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12} md={6} lg={6} className='m-0 p-0'>
                                <div className="right-box-card22 px-0 py-2 px-lg-2 py-lg-2">
                                    <div className="contact-body right-box px-2 py-4 px-sm-2 py-sm-4 px-lg-5 py-lg-5">
                                        <h5 className="card-heading">Enter Your Details</h5>
                                        <p className="card-desc">We take great pride in everything that we do, control over products allows us to ensure our    customers receive the best quality service.</p>
                                        <Form onSubmit={formik.handleSubmit} className="contact-form m-0 p-0">
                                            <Row>
                                                <input type="hidden" name="dn_state" value={formik.values.dn_state} />
                                                <input type="hidden" name="dn_district" value={formik.values.dn_district} />
                                                <input type="hidden" name="dn_city" value={formik.values.dn_city} />
                                                <input type="hidden" name="dn_pinocde" value={formik.values.dn_pinocde} />
                                                {/* <input type="hidden" name="campaign_id" value={(typeof cId !== "undefined" && cId !== "") ? cId : REACT_APP_TEST_RIDE_CAMPAIGN_ID } />
                                                <input type="hidden" name="campaign_source" value={(typeof cSource !== "undefined" && cSource !== "") ? cSource : "website" } /> */}
                                                <Col sm={12} md={12} lg={12}>
                                                    <Form.Control type="text" name="name" placeholder="Name*" onChange={formik.handleChange} value={formik.values.name} />
                                                    {formik.errors.name ? <span className="text-danger">{formik.errors.name}</span> : null}
                                                </Col>
                                                <Col sm={12} md={12} lg={12}>
                                                    <Form.Control type="text" name="email" placeholder="Email*" onChange={formik.handleChange} value={formik.values.email} />
                                                    {formik.errors.email ? <span className="text-danger">{formik.errors.email}</span> : null}
                                                </Col>
                                                <Col sm={12} md={12} lg={12}>
                                                    {/* <Form.Control type="text" name="phone" placeholder="Phone*" maxLength="10" onChange={formik.handleChange} value={formik.values.phone} /> */}
                                                    <Form.Control type="text" name="phone" placeholder="Phone*" maxLength={10} value={formik.values.phone}
                                                        onChange={(e) => {
                                                            const cleaned = CleanNumericInput(e.target.value);
                                                            formik.setFieldValue('phone', cleaned);
                                                        }}
                                                        onPaste={(e) => {
                                                            e.preventDefault();
                                                            const pasted = e.clipboardData.getData('Text');
                                                            const cleaned = CleanNumericInput(pasted);
                                                            formik.setFieldValue('phone', cleaned);
                                                        }}
                                                        onBlur={(e) => {
                                                            const cleaned = CleanNumericInput(e.target.value);
                                                            formik.setFieldValue('phone', cleaned);
                                                        }}
                                                    />
                                                    {formik.errors.phone ? <span className="text-danger">{formik.errors.phone}</span> : null}
                                                </Col>
                                                <Col xs={12} className="atc_select">
                                                    <FormSelect style={{ height: '45px' }} name="enquiried_for_item" onChange={formik.handleChange} value={formik.values.enquiried_for_item}>
                                                        <option defaultValue>Select Model</option>
                                                        <option value="Atum Vader">Atum Vader</option>
                                                        <option value="Atum 1.0">Atum 1.0</option>
                                                    </FormSelect>
                                                    {formik.errors.enquiried_for_item ? <span className="text-danger">{formik.errors.enquiried_for_item}</span> : null}
                                                </Col>
                                                <Col xs={12} className="text-center mt-4">
                                                    <Button type="submit" className="btn btn-primary" id="testRideFormSubmitBtn" disabled={loading}> 
                                                        {loading ?  <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                            Submitting...
                                                        </> : "Submit"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12} md={12} lg={12} className="mt-4">
                                {selectedDealerInfo.dn_latitude && selectedDealerInfo.dn_longitude ? (
                                    <div className="map-container" style={{ height: '450px' }}>
                                        <iframe
                                            src={`https://www.google.com/maps?q=${selectedDealerInfo.dn_latitude},${selectedDealerInfo.dn_longitude}&hl=es;z=15&output=embed`}
                                            width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" title="Test Ride Map"
                                        ></iframe>
                                    </div>
                                ) : (
                                    <div id="address_hyd_map">
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '450px',
                                                backgroundImage: 'url(https://d2tm70q7nw2sv.cloudfront.net/atumobile/assets/images/map-not-available.jpg)',
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                            }}
                                        ></div>
                                    </div>
                                )}
                            </Col>
                        </Row>}
                    </Container>
                </section>
            </Layout>
        </>
    )
}

export default Testride